import { Grid, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import ReactPlayer from "react-player/lazy";
import { useStyles } from "../about-me-mentor.styles";

interface VideoMentorProps {
  videoSource: string;
}

function VideoMentor({ videoSource }: VideoMentorProps) {
  const classes = useStyles();

  return (
    <Grid container spacing={3}>
      <Grid item container spacing={1}>
        <Typography className={classes.title}>About Me</Typography>
      </Grid>
      <Grid item container justifyContent="center" spacing={1}>
        {videoSource ? (
          <ReactPlayer
            url={videoSource}
            controls={true}
            className={classes.videoPlayer}
            width="100%"
            height="auto"
            data-testid="mentor-video-player"
            fallback={
              <Skeleton
                variant="rect"
                className={classes.videoPlayer}
                width="100%"
                height="auto"
              />
            }
          />
        ) : (
          <Grid item spacing={1}>
            <Typography>No video loaded.</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

export default VideoMentor;
